export default {
  "site.title": "Kakobuy Spreadsheet Polska 2026 – Największa Baza Produktów, Finds i Linków",
  "site.description": "Kakobuy Spreadsheet Polska – znajdź najlepsze produkty, listy zakupowe, Kakobuy Finds oraz poradniki bezpieczeństwa. Aktualna baza produktów dla użytkowników z Polski.",

  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.guide": "Przewodnik",
  "nav.blog": "Blog",

  "hero.title": "Kakobuy Spreadsheet Polska",
  "hero.subtitle": "Najprostszy sposób na znalezienie najlepszych produktów i okazji",
  "hero.description": "Przeglądaj aktualizowaną bazę Kakobuy Spreadsheet, poznawaj popularne produkty, porównuj kategorie i korzystaj z kompletnych poradników zakupowych.",
  "hero.cta.primary": "🔥 Zobacz Kakobuy Spreadsheet",
  "hero.cta.secondary": "📚 Przeczytaj przewodnik",
  "hero.badge1": "✓ Niezależny przewodnik",
  "hero.badge2": "✓ Aktualizowane listy produktów",
  "hero.badge3": "✓ Poradniki bezpieczeństwa",
  "hero.badge4": "✓ Polska społeczność",

  "category.dropdown.label": "Wybierz kategorię produktów",
  "category.dropdown.placeholder": "Kliknij, aby wybrać kategorię...",

  "about.title": "Czym jest Kakobuy Spreadsheet?",
  "about.content": "Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć interesujące produkty, porównać opcje i zaoszczędzić czas podczas zakupów online. To kompleksowe narzędzie, które łączy w sobie listy produktów, porównania cen oraz informacje o dostępności, dzięki czemu każdy użytkownik może podejmować świadome decyzje zakupowe bez konieczności przeszukiwania dziesiątek stron internetowych.",

  "benefits.title": "Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?",
  "benefits.1.title": "Szybsze wyszukiwanie",
  "benefits.1.desc": "Nie trać godzin na ręczne szukanie produktów. Wszystko masz w jednym miejscu.",
  "benefits.2.title": "Kategorie produktów",
  "benefits.2.desc": "Sneakers, ubrania, akcesoria i wiele więcej – wszystko uporządkowane.",
  "benefits.3.title": "Porównania",
  "benefits.3.desc": "Tabela pomaga wybrać najlepszą opcję spośród dostępnych produktów.",
  "benefits.4.title": "Bezpieczeństwo",
  "benefits.4.desc": "Dowiedz się jak ograniczyć ryzyko zakupów i uniknąć potencjalnych oszustw.",

  "safety.title": "Czy Kakobuy jest bezpieczny?",
  "safety.subtitle": "7 rzeczy, które musisz wiedzieć przed zakupem",
  "safety.content": "Bezpieczeństwo zakupów online jest priorytetem dla każdego użytkownika. Kakobuy to platforma, która zyskała zaufanie tysięcy klientów na całym świecie. Przed dokonaniem zakupu warto zapoznać się z podstawowymi zasadami bezpieczeństwa, sprawdzić opinie innych użytkowników oraz korzystać ze sprawdzonych metod płatności. Regularnie aktualizowana baza produktów pozwala na bieżąco śledzić najnowsze informacje i unikać nieaktualnych ofert.",

  "article.preview.title": "Przeczytaj nasz przewodnik",
  "article.preview.desc": "Kompletny przewodnik po Kakobuy Spreadsheet dla polskich użytkowników. Dowiedz się jak znaleźć najlepsze produkty, porównać ceny i zaoszczędzić czas.",
  "article.preview.cta": "Czytaj więcej →",

  "cta.buynow": "Kup teraz",
  "cta.spreadsheet": "Kakobuy Spreadsheet",

  "footer.copyright": "© 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Ta strona jest niezależnym przewodnikiem i nie jest powiązana z Kakobuy. Wszystkie linki prowadzą do zewnętrznych stron."
}